export enum PermissionType {
    IsNone = 1,
    IsView = 2,
    IsEdit = 3,
}